import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormField, InputAdornment, NumberInput } from '@cian/ui-kit';
import { selectPaymentAmount } from '../../../selectors/checkout';
import { selectAmountError, selectIsDepositAmountVisible } from '../../../selectors/layout';
import { setPaymentAmount } from '../../../actions/checkout';

export const DepositAmountContainer = () => {
  const value = useSelector(selectPaymentAmount);
  const isVisible = useSelector(selectIsDepositAmountVisible);
  const amountError = useSelector(selectAmountError);

  const dispatch = useDispatch();

  const handleAmountChange = React.useCallback(
    (value: number) => {
      dispatch(setPaymentAmount(value));
    },
    [dispatch],
  );

  if (!isVisible) {
    return null;
  }

  return (
    <FormField label="Сумма" errorMessage={amountError} withoutMargin>
      <NumberInput
        placeholder="Введите сумму"
        size="M"
        rightAdornment={<InputAdornment>₽</InputAdornment>}
        value={value}
        invalid={!!amountError}
        onChange={handleAmountChange}
        data-testid="widget|input|amount"
      />
    </FormField>
  );
};
